import { ConfigService } from './shared/services/config.service';
import { Router, RouterEvent, Event } from '@angular/router';
import { YesNoDialogComponent } from './shared/components/yes-no-dialog/yes-no-dialog.component';
import { TokenService } from './shared/services/token.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbDialogService } from '@nebular/theme';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ApiServiceService } from './shared/services/api-service.service';
import { db } from './shared/db/db';
import { SwUpdate } from '@angular/service-worker';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy{
  title = 'alertas';
  showBtnCloseSession = false;
  tokenSubscription: Subscription;

  constructor(
    public tokenService: TokenService,
    private dialogService: NbDialogService,
    private router: Router,
    private configService: ConfigService,
    private apiService: ApiServiceService,
    private updates: SwUpdate
    ) {

      router.events.pipe(
        filter((e: Event): e is RouterEvent => e instanceof RouterEvent)
     ).subscribe((e: RouterEvent) => {
       this.showBtnCloseSession = e.url == "/" || e.url == "/advancedhome";
     });
  }

  ngOnInit(): void {
    this.tokenService.tokenSubject.subscribe(token => {
      this.showBtnCloseSession = token != null;    
    });
  }

  closeSession(): void {
    this.dialogService.open(YesNoDialogComponent, { context: {
      title: "Cerrar sesión",
      message: '¿Está seguro que desea cerrar sesión?'
    }}).onClose.subscribe(result => {
      if (result){
        this.tokenService.removeToken();
        this.configService.cleanConfig();
        this.router.navigate(["login"]);
        db.cleanDatabase();
        this.updates.activateUpdate().then(() => document.location.reload());
      }
    });
  }

  ngOnDestroy(): void {
    if (this.tokenSubscription)  {
      this.tokenSubscription.unsubscribe();
    }
  }

  get subdomain() {
    return this.apiService.getSubDominio();
  }

  public throwTestError(): void {
    throw new Error("Sentry Test Error");
  }
}
